import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { UserService } from '../user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModaleSuccessoComponent } from '../../../../shared/components/modali/modale-successo/modale-successo.component';

@Component({
	selector: 'app-cambia-password',
	imports: [FormsModule, HeaderComponent],
	templateUrl: './cambia-password.component.html',
})
export class CambiaPasswordComponent {
	router = inject(Router);
	authService = inject(AuthService);
	userService = inject(UserService);
	modalService = inject(NgbModal);

	nuovaPassword = signal('');
	confermaNuovaPassword = signal('');
	showNew = signal(false);
	showConfirm = signal(false);
	loading = signal(false);
	error = signal(false);
	errorMsg = signal('');

	cambia() {
		this.error.set(false);

		let utente = this.authService.currentUser;
		if (!utente) {
			return;
		}

		if (!this.nuovaPassword() || !this.confermaNuovaPassword()) {
			this.error.set(true);
			this.errorMsg.set('Tutti i campi sono obbligatori.');
			return;
		}

		if (this.nuovaPassword() !== this.confermaNuovaPassword()) {
			this.error.set(true);
			this.errorMsg.set('Le password non coincidono.');
			return;
		}

		this.loading.set(true);

		utente.password = this.nuovaPassword();
		this.userService.updateUtente(utente).subscribe({
			next: (updated) => {
				this.loading.set(false);
				localStorage.setItem('user', JSON.stringify(updated));
				const modalRef = this.modalService.open(ModaleSuccessoComponent, { centered: true, windowClass: 'modal-app-custom' });
				modalRef.componentInstance.title = 'Password cambiata';
				modalRef.componentInstance.message = 'La tua password è stata modificata con successo.';
				modalRef.result.then(() => {
					this.goBack();
				}, () => {
					this.goBack();
				});
			},
			error: (updated) => {
				this.loading.set(false);
				this.error.set(true);
				this.errorMsg.set('Si è verificato un errore: ' + updated.message);
			},
		});
	}

	goBack() {
		this.router.navigate(['/app/dashboard/profilo']);
	}

	checkPassword(password: string) {
		this.error.set(!this.validatePassword(password));
		if (this.error()) {
			this.errorMsg.set('La password non è abbastanza forte');
		}
	}

	validatePassword(password: string): boolean {
		if (!password || password.length < 8) return false;

		const hasSpecial = /[^A-Za-z0-9]/.test(password); // carattere speciale
		if (!hasSpecial) return false;

		const rules = [
			/[A-Z]/.test(password), // maiuscola
			/[a-z]/.test(password), // minuscola
			/[0-9]/.test(password), // numero
			hasSpecial, // carattere speciale
		];

		const passedRules = rules.filter((r) => r).length;

		return passedRules >= 3;
	}
}
